import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {HelpersService} from '../../helpers.service';
import {IAssignedQueue} from 'src/app/viba/admin/queues/queue';
import {QueueService} from 'src/app/viba/admin/queues/queue.service';

@Component({
    selector: 'app-assigned-queues',
    templateUrl: './assigned-queues.component.html',
    styleUrls: ['./assigned-queues.component.scss'],
    standalone: false
})
export class AssignedQueuesComponent {

  @Input() formGroup: FormGroup;

  _initialQueueIds: number[];
  private _queuesLoaded = true;
  @Output() onChange = new EventEmitter();

  @Input()
  set initialQueueIds(queueIds: number[]) {
    if (queueIds === null) {
      queueIds = [];
    }

    if (this.helpersService.arraysEqual(this._initialQueueIds, queueIds)) {
      // already computed assigned queues
      return;
    }

    this._initialQueueIds = queueIds;
    this._queuesLoaded = false;
    this.queueService.getAllQueuesWithAssignedInfo(this._initialQueueIds).subscribe(next => {
        this.assignedQueues = next.items;
        this._queuesLoaded = true;
      },
      error => this._queuesLoaded = true);
  }

  assignedQueues: IAssignedQueue [] = [];

  public get updatedQueueIds() {
    if (!this._queuesLoaded) {
      return this.initialQueueIds;
    }

    const updatedQueueIds: number[] = [];
    this.assignedQueues.forEach(assignedQueue => {
      if (assignedQueue.assigned) {
        updatedQueueIds.push(assignedQueue.queue.id);
      }
    });
    return updatedQueueIds;
  }

  constructor(
    public helpersService: HelpersService,
    public queueService: QueueService,
  ) {
  }

  toggleQueue(assignedQueue: IAssignedQueue) {
    assignedQueue.assigned = !assignedQueue.assigned;
    this.onChange.emit(assignedQueue);
    this.formGroup.markAsDirty();
  }
}
